export default {
    title: '字根',

    level: {
        format: '{level}级',
        nextLevel: '下一级',
        currentLevel: '当前级别',
    },

    session: {
        count: '{count}次',
        exam: '小测验',
        examScore: '{score}分',
        study: '学习',
        completed: '完成',
        locked: '锁定',
        inProgress: '进行中',
    },

    navigation: {
        toWaitingRoom: '前往等候室',
        toStudy: '开始学习',
        toExam: '参加考试',
        continue: '继续',
        stop: '中断',
    },

    study: {
        start: '开始',
        continue: '继续',
        complete: '完成',
        stop: '中断',
        stopConfirm: '确定要停止学习吗？',
        example: '例句',
        meaning: '含义',
        sound: '发音',
        listen: '听发音',
    },

    exam: {
        start: '开始',
        grade: '评分',
        result: '查看结果',
        questions: {
            intro: '开始答题',
            upper: '上方字问题',
            lower: '下方字问题',
        },
    },

    modal: {
        studyComplete: {
            title: '学习完成',
            message: '恭喜！您已完成学习。',
        },
        examComplete: {
            title: '考试完成',
            message: '考试已完成。',
        },
        stopConfirm: {
            title: '停止学习',
            message: '确定要停止学习吗？<br/>学习进度可能无法保存。',
        },
    },

    errors: {
        audioPlay: '音频播放出现问题',
        loadData: '加载数据时出现错误',
    },
};
